import _ from 'lodash';
import { connect } from 'react-redux';
import { fetchChatUsers, fetchChatUser, fetchLocationsChatUsers } from 'src/legacy/redux/actions/chatUsers.jsx';
import { initiateSmallTalkSession, invalidateSmallTalkSession } from 'src/legacy/redux/actions/smallTalk.jsx';

import SmallTalkView from './view.jsx';
import hasAccess from 'src/legacy/services/hasAccess.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks'

// import { trackAdoptionMetricsForViewerFilterAppliedEvent, trackAdoptionMetricsForAllRecipientsToggledEvent, trackAdoptionMetricsForRecipientSelectedEvent } from 'src/actions/adoption.jsx';

const mapStateToProps = (state) => {

  return {
    account: _.get(state, "accounts.item"),
    chatUsers: _.get(state.legacyRootReducer, `chatUser.items`),
    contact: _.get(state.legacyRootReducer, `chatUser.item`),
    engageEnabled: _.get(state.legacyRootReducer, `smallTalk.initiated`),
    loading: _.get(state.legacyRootReducer, `chatUser.loading`),
    totalRecords: _.get(state.legacyRootReducer, `chatUser.pagination.totalRecordsCount`),
    currentPage: _.get(state.legacyRootReducer, `chatUser.pagination.currentPage`),
    totalPages: _.get(state.legacyRootReducer, `chatUser.pagination.totalPages`)
  }

}

const mapDispatchToProps = (dispatch) => {
  return {

    fetchChatUsers: (page, filter, global) => {
      return dispatch(fetchChatUsers(page, filter, global));
    },

    fetchChatUser: (chatUserId) => {
      return dispatch(fetchChatUser(chatUserId));
    },

    initiateSmallTalkSession: (contact) => {
      return dispatch(initiateSmallTalkSession(contact));
    },

    invalidateSmallTalkSession: (contact) => {
      return dispatch(invalidateSmallTalkSession(contact));
    },

    fetchLocationsChatUsers: (filter, global) => {
      return dispatch(fetchLocationsChatUsers(filter, global));
    },

    // trackAdoptionMetricsForViewerFilterAppliedEvent: (filter) => {
    //   return dispatch(trackAdoptionMetricsForViewerFilterAppliedEvent(filter));
    // },

    // trackAdoptionMetricsForAllRecipientsToggledEvent: () => {
    //   return dispatch(trackAdoptionMetricsForAllRecipientsToggledEvent());
    // },

    // trackAdoptionMetricsForRecipientSelectedEvent: () => {
    //   return dispatch(trackAdoptionMetricsForRecipientSelectedEvent());
    // }
  }
}

const SmallTalkPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(SmallTalkView)

export default withUseHooks(SmallTalkPage, 'engage');